import React, { useState, useRef } from 'react';
import './Mobile.css';

const Mobile = () => {
  const [showMobileRedCard, setShowMobileRedCard] = useState(false);
  const [showMobileBlueCard, setShowMobileBlueCard] = useState(false);
  const [transitioning, setTransitioning] = useState(false);
  const touchStartX = useRef(0);

  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchMove = (e) => {
    const touchEndX = e.touches[0].clientX;
    const distance = touchEndX - touchStartX.current;

    if (transitioning) return; // Prevent new transitions while transitioning

    if (!showMobileRedCard && !showMobileBlueCard && distance > 50) {
      setShowMobileRedCard(true); // Swipe right to show the red card
      setTransitioning(true);
      setTimeout(() => setTransitioning(false), 300); // Delay to allow transition to complete
    } else if (showMobileRedCard && distance < -50) {
      setShowMobileRedCard(false); // Swipe left to hide the red card
      setTransitioning(true);
      setTimeout(() => setTransitioning(false), 300); // Delay to allow transition to complete
    }

    if (!showMobileBlueCard && !showMobileRedCard && distance < -50) {
      setShowMobileBlueCard(true); // Swipe left to show the blue card
      setTransitioning(true);
      setTimeout(() => setTransitioning(false), 300); // Delay to allow transition to complete
    } else if (showMobileBlueCard && distance > 50) {
      setShowMobileBlueCard(false); // Swipe right to hide the blue card
      setTransitioning(true);
      setTimeout(() => setTransitioning(false), 300); // Delay to allow transition to complete
    }
  };

  return (
    <div className="mobile-container" onTouchStart={handleTouchStart} onTouchMove={handleTouchMove}>
      <h1 className="mobile-header mobile-font-thin leading-none unselectable">
        <span className="mobile-font-thin">OBERO</span>
        <span className="mobile-font-semibold">N≥X</span>
      </h1>
      <div className="mobile-subtext">
        <span className="mobile-font-semibold">QUANT </span>
        <span className="mobile-font-thin-text">SOLUTIONS </span>
        <span className="mobile-font-thin-text">FOR </span>
        <span className="mobile-font-semibold">COMMODITY </span>
        <span className="mobile-font-thin-text">MARKETS</span>
      </div>
      <div className="mobile-contact-text">
        <span className="mobile-font-thin">{'<'}CONTACT{'>'} </span>
      </div>
      <div className="mobile-email-text">
        <span className="mobile-font-bold-email">hello@oberon-x.com</span>
      </div>
      <div className={`mobile-red-card ${showMobileRedCard ? 'visible' : ''}`}>
        <div className="mobile-text-thin">
          We design State of the Art Solutions for commodities markets, from the trading desk to the back office. A multidisciplinary team with more than 15 years of experience in developing, testing, and deploying top of the line solutions for the most demanding industries.
        </div>
        <div className="mobile-algorithms">
          <span className="mobile-bold">ALGORITHMS </span>
          <span className="mobile-thin">AS A </span>
          <span className="mobile-bold">SERVICE </span>
          <span className="mobile-thin">IS WHAT WE DO</span>
        </div>
        <div className="mobile-commodities">
          <span className="mobile-bold">COMMODITIES </span>
          <span className="mobile-thin">IS WHAT </span>
          <span className="mobile-bold">WE THRIVE ON</span>
        </div>
      </div>
      <div className={`mobile-blue-card ${showMobileBlueCard ? 'visible' : ''}`}>
        <div className="mobile-text-algorithms">&lt;/ALGORITHMS&gt;</div>
        <div className="mobile-paragraph-algorithms">Fully or Semi-Automated Trading Solutions.</div>
        <div className="mobile-text-indicators">&lt;/INDICATORS&gt;</div>
        <div className="mobile-paragraph-indicators">Visual Decision-Making Assistance.</div>
        <div className="mobile-paragraph-indicators2">See, Analize & Trade with logical consistence.</div>
        <div className="mobile-text-real-time-data">&lt;/REAL TIME DATA&gt;</div>
        <div className="mobile-paragraph-real-time-data-1">Real Time Data Feeds for the Quotations that move the World.</div>
        <div className="mobile-paragraph-real-time-data-2">Contact us for more Information.</div>
      </div>
      <div className="mobile-vertical-tab left">
        ABOUT
      </div>
      <div className="mobile-vertical-tab right">
        PRODUCTS
      </div>
    </div>
  );
};

export default Mobile;
